import React from 'react';
import PropTypes from 'prop-types';

const WiFiWarningPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M19.543 17.962a7.025 7.025 0 0 1 2.227 2.075l-2.277 2.014a4.03 4.03 0 0 0-1.012-1.188 3.505 3.505 0 0 0 1.017-2.374l.045-.527zm-7.088 0a7.043 7.043 0 0 0-2.204 2.042l2.275 2.011c.255-.445.593-.837.993-1.153a3.503 3.503 0 0 1-1.018-2.373l-.046-.527zm7.63-6.307a13.033 13.033 0 0 1 6.198 4.391L24.03 18.04a10.038 10.038 0 0 0-4.21-3.284l.266-3.1zm-8.172 0a13.032 13.032 0 0 0-6.173 4.36l2.253 1.992a10.04 10.04 0 0 1 4.187-3.252l-.267-3.1zm8.125-6.225a18.998 18.998 0 0 1 10.746 6.636l-2.25 1.99a16.011 16.011 0 0 0-8.186-5.458l.085-.988a4.33 4.33 0 0 0-.395-2.18zm-8.074 0A18.996 18.996 0 0 0 1.24 12.033l2.25 1.99a16.012 16.012 0 0 1 8.16-5.426l-.084-.988a4.305 4.305 0 0 1 .398-2.18zM16 27.396a2.244 2.244 0 0 0 2.25-2.25 2.244 2.244 0 0 0-2.25-2.25 2.244 2.244 0 0 0-2.25 2.25 2.244 2.244 0 0 0 2.25 2.25zM18.44 7.46C18.541 6.095 17.518 5 16.153 5h-.308c-1.358 0-2.388 1.101-2.285 2.46l.939 10.926c0 .832.672 1.51 1.5 1.51.834 0 1.5-.676 1.5-1.51l.94-10.926z"
    />
  );
};

WiFiWarningPath.propTypes = {
  fill: PropTypes.string,
};

export default WiFiWarningPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/wifi-warning.jsx